import camelcaseKeys from 'camelcase-keys';

import browser from '@openclassrooms/utils/browser';

import Autocomplete from '../Autocomplete';
import AutocompleteMultiple from '../AutocompleteMultiple';

export const DIRECTIVES_VALUES = {
  SIMPLE: 'Autocomplete',
  MULTIPLE: 'AutocompleteMultiple',
};

function isPropertyValid(property) {
  return property.name !== 'data-react' && property.name !== 'data-props' && property.nodeValue;
}

function transformPropertyName(propertyName) {
  const mapping = {
    maxlength: 'maxLength',
    class: 'className',
  };

  return mapping[propertyName] || propertyName;
}

function transformPropertyValue(propertyName, propertyValue) {
  switch (propertyName) {
    case 'style': {
      const tempDiv = browser.document.createElement('div');
      tempDiv.setAttribute('style', propertyValue);

      const style = {};

      for (let i = 0, l = tempDiv.style.length; i < l; i += 1) {
        const propName = tempDiv.style.item(i);
        style[propName] = tempDiv.style.getPropertyValue(propName);
      }

      return camelcaseKeys(style);
    }

    default:
      return propertyValue;
  }
}

function combineProperties(allProperties, property) {
  return {
    ...allProperties,
    [transformPropertyName(property.name)]: transformPropertyValue(
      property.name,
      property.nodeValue
    ),
  };
}

function AutocompleteFromDom({ input = null, multiple = false, ...otherProps }) {
  const props = [...input.attributes].filter(isPropertyValid).reduce(combineProperties, {});
  const AutocompleteComponent = multiple ? AutocompleteMultiple : Autocomplete;

  return <AutocompleteComponent {...props} required={input.required} {...otherProps} />;
}

export default AutocompleteFromDom;
